import {API_URL, THEME_COLOR} from "../constant"
import React, { useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { Link,  useHistory } from "react-router-dom";
import { Redirect } from 'react-router';
import jwt  from 'jsonwebtoken';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


// class Login extends React.Component{
//     constructor(props){
//         super(props);

//     }
    
//     render(){
        
//     }
// }

const Login = (props)=>{
    let history = useHistory();
    
    const [token, setToken] = useLocalStorage("token", "");
    const [lastViewedItem, setLastViewedItem] = useLocalStorage("lastViewedItem", "");
    const [username, setUsername] = useLocalStorage("username", "");
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

    async function LoginUser(){

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("username", username);
        urlencoded.append("password", password);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/auth/login`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))

        // return fetch(`${API_URL}api/auth/login`,{
        //     method: "POST",
        //     // mode: "no-cors",
        //     headers : {
        //         'Content-Type' : 'application/x-www-form-urlencoded'
        //     },
        //     form:{
        //         'username': username,
        //         'password': password
        //     }
        // }).then(data => data.json())
        // return {
        //     status:200,
        //     token: "abc"
        // }
    }

    async function SubmitHandler(event){
        event.preventDefault();
        setIsOpenBackdrop(true)
        setErrorMessage('') 
        let response = await LoginUser();
        response = JSON.parse(response);
        if(response.status == 200){
            let token = jwt.decode(response.token);
            setToken(response.token);
            setLastViewedItem("");
            console.log(token)
            if(token.ChangeStatus == 0){
                window.location = `/editprofile`;
            }else{
                window.location = `${history.location.state.from.pathname}`;
            }
            // history.push(history.location.state.from.pathname)
            // console.log(history);
        }else{
            setErrorMessage(response.message)
        }
        setIsOpenBackdrop(false);
    }

    async function ContinueAsGuest(event){
        event.preventDefault();
        setIsOpenBackdrop(true)
        window.location = `/shopnow/guest`;
        setIsOpenBackdrop(false);
    }

    return(
        <React.StrictMode>
            <HeaderBack title="Login"/>
            <div className="row">
                <form className="col s12">
                    <div className="row">
                        <div className="input-field col s12">
                            <i className="material-icons prefix">account_circle</i>
                            <input id="Username" type="text" className="validate" onChange={ e => setUsername(e.target.value)}/>
                            <label htmlFor="Username">Username</label>
                        </div>
                        <div className="input-field col s12">
                            <i className="material-icons prefix">lock</i>
                            <input id="Password" type="password" className="validate" onChange={ e => setPassword(e.target.value)}/>
                            <label htmlFor="Password">Password</label>
                        </div>
                        <div className="col s12 red-text text-darken-3" id="error-message" style={{padding: "10px"}}>
                            {errorMessage}
                        </div>
                        {/* <div class="col s2"></div> */}
                        <div className="col s12 center">
                            <a className={`btn ${THEME_COLOR}`} style={{minWidth:"50%"}} onClick={SubmitHandler}><i></i>Login</a>
                        </div>
                        <div class="col s12 center">
                            <span>or <Link to="/forgotpassword">Forgot Passoword?</Link></span>
                        </div>
                        <div className="col s12 center" style={{marginTop:"10px"}}>
                            <a style={{minWidth:"50%",color:"#ff3d00",cursor:"pointer"}} onClick={ContinueAsGuest}><i></i>Continue as Guest</a>
                        </div>
                        
                    </div>
                    <hr />
                    <div className="row center">
                        <Link style={{minWidth:"50%"}} className="btn" to="/signup">Register New Member</Link>
                    </div>
                </form>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    );
}

export default Login;
